import {
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Slider,
  Space,
  Table,
} from 'antd';
import { EyeIcon, FilterGoldIcon, FilterIcon } from 'assets/svg';
import Button from 'components/Button';
import React, { useEffect, useState } from 'react';

import type { ColumnsType } from 'antd/es/table';
import { Content } from 'antd/es/layout/layout';
import { useMutation, useQuery } from 'react-query';
import AllocateApi from 'apis/AllocateApi';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import moment from 'moment';
import { openNotificationWithIcon } from 'utils/notification';
import { translateStatusAllcatedetail } from 'utils/translateStatus';
import { HocChangePagination } from 'utils/HocChangePagination';
import { useHistory } from 'react-router-dom';
import { useForm } from 'antd/es/form/Form';
import PriceSlider from 'components/PriceSlider';

type FixedType = 'left' | 'right' | boolean;
interface IProps {
  capital_branch_id: number;
  totalCapitalMax: any;
}

export default function StoreTable(props: IProps): JSX.Element {
  const { capital_branch_id, totalCapitalMax } = props;
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const queryParam = useQueryParam();
  const history = useHistory();
  const { Option } = Select;
  const [form] = useForm();
  const [shopId, setShopId] = useState<any>();
  const [total, setTotal] = useState<number>(0);
  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const [capitalOption, setCapitalOption] = useState<any>();

  const [capitalAllocate, setCapitalAllocate] = useState<any>();
  const [formSubmitParams, setFormSubmitParams] = useState<any>();

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã cửa hàng',
      dataIndex: 'shop',
      width: 150,
      render: (record: any) => {
        return record?.code;
      },
    },
    {
      title: 'Tên cửa hàng',
      dataIndex: 'shop',
      width: 280,
      render: (record: any) => {
        return record?.name;
      },
    },
    {
      title: 'Vốn phân bố tối thiểu (MIN)',
      dataIndex: 'capital_min',
      width: 250,
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Vốn phân bố tối đa (MAX)',
      dataIndex: 'capital_max',
      width: 250,
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    // {
    //   title: 'Vốn đăng kí MIN',
    //   width: 250,
    // },
    // {
    //   title: 'Vốn đăng kí MAX',
    //   width: 250,
    // },
    // {
    //   title: 'Trạng thái',
    //   dataIndex: 'status',
    //   width: 150,
    //   render: (_: any, record: any) => (
    //     <span>{translateStatusAllcatedetail(record.status)}</span>
    //   ),
    // },
    // {
    //   title: 'Trạng thái phân bố',
    //   width: 250,
    // },
    {
      title: 'Mã công ty',
      dataIndex: 'shop',
      width: 120,
      render: (record: any) => {
        return record?.companyId;
      },
    },
    // {
    //   title: 'Tên công ty',
    //   width: 120,
    // },
    // {
    //   title: 'Vùng miền',
    //   width: 250,
    // },
    // {
    //   title: 'Mã DC',
    //   width: 100,
    // },
    {
      title: 'Tỉnh thành',
      dataIndex: 'shop',
      width: 250,
      render: (record: any) => {
        return record?.city;
      },
    },
    {
      title: 'Quận huyện',
      dataIndex: 'shop',
      width: 250,
      render: (record: any) => {
        return record?.district;
      },
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'shop',
      width: 280,
      render: (record: any) => {
        return record?.address;
      },
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'shop',
      width: 120,
      render: (record: any) => {
        return record?.phoneNumber;
      },
    },
    {
      title: 'Tier cửa hàng',
      dataIndex: 'shop',
      width: 150,
      render: (record: any) => {
        return record?.tier;
      },
    },
    // {
    //   title: 'Mô hình cửa hàng',
    //   dataIndex: 'shop',
    //   width: 180,
    //   render: (record: any) => {
    //     return record?.typeCode;
    //   },
    // },
    {
      title: 'Kênh cửa hàng',
      dataIndex: 'shop',
      width: 150,
      render: (record: any) => {
        return record?.channelName;
      },
    },
    {
      title: 'Ngày khai trương',
      dataIndex: 'shop',
      width: 150,
      render: (record: any) => {
        return record?.createdAt
          ? moment(record?.createdAt).format('DD/MM/YYYY')
          : '';
      },
    },
    {
      title: 'Cấp cửa hàng',
      dataIndex: 'shop',
      width: 150,
      render: (record: any) => {
        return record?.className;
      },
    },
    {
      title: 'Ngày chỉnh sửa',
      dataIndex: 'shop',
      width: 150,
      render: (record: any) => {
        return record?.updatedAt
          ? moment(record?.updatedAt).format('DD/MM/YYYY')
          : '';
      },
    },
    {
      // title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 1,
      render: (record: any) => (
        <div className="flex justify-around items-center gap-4">
          {/* <div>
            <EyeIcon />
          </div> */}
          {/* <div>
            <CheckIcon />
          </div>
          <div>
            <CategoryCancel />
          </div> */}
        </div>
      ),
    },
  ];
  const onSelectChange = (selectedRows: any) => {
    setShopId(selectedRows);
  };
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      onSelectChange(selectedRows);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  const [page, setPage] = useState(parseInt(queryParam.get('page') + '') || 1);
  const [options, setOptions] = useState<boolean>(true);
  const [page_size, setPage_size] = useState(
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE
  );
  const userParams = {
    page,
    page_size,
    options,
    ...(formSubmitParams && formSubmitParams),
  };

  const { data: lstOption } = useQuery(['getAllDivision'], () =>
    AllocateApi.getOptionList()
  );

  const { mutate: getData } = useMutation(
    ['get'],
    () => AllocateApi.getCapitalAllocation(capital_branch_id, userParams),
    {
      onSuccess: (response: any) => {
        if (response.status === STATUS.SUCCESS) {
          setCapitalAllocate(response?.data);
          setTotal(response?.total);
          if (options == true) {
            const price = {
              min: Number(response?.optionsList.min_capital),
              max: Number(response?.optionsList.max_capital),
            };
            setCapitalOption(price);
          }
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const { mutate: updateStatusDetails } = useMutation(
    AllocateApi.updateStatusListDetails,
    {
      onSuccess: (data: any) => {
        if (data.status === 200) {
          openNotificationWithIcon('success', 'Duyệt thành công');
        }
      },
      onError: () => {
        openNotificationWithIcon('error', 'Duyệt thất bại');
      },
    }
  );

  useEffect(() => {
    if (capital_branch_id != null || capital_branch_id != undefined) getData();
  }, [page, page_size, capital_branch_id, formSubmitParams]);

  const handleUpdateStatus = () => {
    const list_shop_id = [];
    for (let i = 0; i < shopId.length; i++) {
      list_shop_id.push(shopId[i].shop_id);
    }
    const params = {
      capital_branch_id: capital_branch_id,
      list_shop_ids: list_shop_id,
      status: 1,
    };
    updateStatusDetails(params);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (
        key == 'plantId' ||
        key == 'district' ||
        key == 'typeCode' ||
        key == 'tier' ||
        key == 'channelName' ||
        key == 'classCode'
      ) {
        stringifiedData[key] = filteredData[key];
      } else if (key == 'capital') {
        stringifiedData['capitalMin'] = values.capital[0];
        stringifiedData['capitalMax'] = values.capital[1];
      } else {
        stringifiedData[key] = filteredData[key];
      }
    });
    setOptions(false);
    setFormSubmitParams(stringifiedData);
    setPage(1);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const plantId = lstOption?.data?.filter(
    (option: any) => option.type === 'plantName'
  )[0]['list'];

  const district = lstOption?.data?.filter(
    (option: any) => option.type === 'district'
  )[0]['list'];

  const typeCode = lstOption?.data?.filter(
    (option: any) => option.type === 'type_code'
  )[0]['list'];

  const tier = lstOption?.data?.filter(
    (option: any) => option.type === 'tier'
  )[0]['list'];

  const channelName = lstOption?.data?.filter(
    (option: any) => option.type === 'channelName'
  )[0]['list'];

  const classCode = lstOption?.data?.filter(
    (option: any) => option.type === 'classCode'
  )[0]['list'];

  return (
    <div>
      <Row justify="end">
        <Button
          bgColor={'bg-white'}
          color={`${isOpenFilter ? 'text-primary-50' : 'text-secondary-50'}`}
          border={`${
            isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
          }`}
          onClick={toggleFilter}
        >
          {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
          Lọc
        </Button>
      </Row>

      <Form
        form={form}
        layout="vertical"
        className={` ${isOpenFilter ? '' : 'hidden'} mt-4`}
        onFinish={onFinish}
        autoComplete="off"
        size="small"
      >
        <Content style={{ paddingTop: '10px', paddingBottom: '10px' }}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={6}>
              <Form.Item
                name="plantId"
                label="Mã cửa hàng"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select
                  showSearch
                  size="small"
                  placeholder="Mã cửa hàng"
                  // mode="multiple"
                  maxTagCount="responsive"
                  allowClear
                  optionFilterProp="children"
                >
                  {plantId &&
                    plantId.map((item: any) => (
                      <Option key={item.id} value={item.id}>
                        {item.code}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="plantName"
                label="Tên cửa hàng"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Input
                  style={{ padding: '9px 10px' }}
                  size="small"
                  placeholder="Nhập tên cửa hàng"
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="capital"
                label="Vốn phân bổ tối thiểu"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                {capitalOption && (
                  <PriceSlider
                    form={form}
                    name="capital"
                    price={capitalOption}
                  />
                )}
              </Form.Item>
            </Col>

            {/* <Col span={6}>
              <Form.Item
                name="capitalMax"
                label="Vốn phân bổ tối đa"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <InputNumber
                  addonAfter="VNĐ"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                  placeholder="Nhập số vốn tối đa"
                  style={{
                    width: '100%',
                    marginTop: '2px',
                  }}
                  size="large"
                />
              </Form.Item>
            </Col> */}

            {/* <Col span={6}>
              <Form.Item
                name="district"
                label="Quận huyện"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select
                  showSearch
                  size="small"
                  placeholder="Quận huyện"
                  // mode="multiple"
                  maxTagCount="responsive"
                  allowClear
                  optionFilterProp="children"
                >
                  {district &&
                    district.map((item: any) => (
                      <Option key={item.district} value={item.district}>
                        {item.district}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col> */}
          </Row>

          {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={6}>
              <Form.Item
                name="typeCode"
                label="Mô hình kinh doanh"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select
                  size="small"
                  placeholder="Mô hình kinh doanh"
                  // mode="multiple"
                  maxTagCount="responsive"
                  allowClear
                  optionFilterProp="children"
                >
                  {typeCode &&
                    typeCode.map((item: any) => (
                      <Option key={item.type_code} value={item.type_code}>
                        {item.type_code}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="tier"
                label="Tier"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select
                  size="small"
                  placeholder="Tier"
                  // mode="multiple"
                  maxTagCount="responsive"
                  allowClear
                  optionFilterProp="children"
                >
                  {tier &&
                    tier.map((item: any) => (
                      <Option key={item.tier} value={item.tier}>
                        {item.tier}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="channelName"
                label="Kênh"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select
                  size="small"
                  placeholder="Kênh"
                  // mode="multiple"
                  maxTagCount="responsive"
                  allowClear
                  optionFilterProp="children"
                >
                  {channelName &&
                    channelName.map((item: any) => (
                      <Option key={item.channel_name} value={item.channel_name}>
                        {item.channel_name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="classCode"
                label="Cấp cửa hàng"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select
                  size="small"
                  placeholder="Cấp cửa hàng"
                  // mode="multiple"
                  maxTagCount="responsive"
                  allowClear
                  optionFilterProp="children"
                >
                  {classCode &&
                    classCode.map((item: any) => (
                      <Option key={item.class_code} value={item.class_code}>
                        {item.class_code}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row> */}

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mt-1.5"
          >
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Table
        rowKey={(record) => record.id}
        scroll={{ x: 958 }}
        className="customTable mt-4"
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        columns={columns}
        dataSource={capitalAllocate}
        pagination={{
          className: 'flex items-center',
          current: page,
          pageSize: page_size,
          total: total,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPage_size(pageSize);
            history.push('/branchs-capital-detail/', {
              page: page,
              page_size: pageSize,
              capital_branch_id: capital_branch_id,
            });
          },
        }}
      />
    </div>
  );
}
